export default "__VITE_ASSET__CFYfFRVk__"